module.exports = __webpack_public_path__ + "img/jesus-pro.24f87a39.jpg";